module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form-group', {
    attrs: {
      "label": _vm.label,
      "id": _vm.elementId,
      "cols": _vm.cols
    }
  }, [_c('select', {
    ref: "select",
    staticClass: "form-control",
    attrs: {
      "id": _vm.elementId,
      "multiple": _vm.multiple !== null
    },
    on: {
      "input": _vm.updateModel
    }
  }, _vm._l((_vm.options), function(o) {
    return _c('option', {
      domProps: {
        "value": o,
        "selected": _vm.multiple !== null ? _vm.value.indexOf(o) !== -1 : JSON.stringify(o) === JSON.stringify(_vm.value),
        "innerHTML": _vm._s(o[_vm.optionText] ? o[_vm.optionText] : o)
      }
    })
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43ccae9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ccae9a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/form/select.vue
// module id = 407
// module chunks = 1